module.exports = __webpack_public_path__ + "static/media/floorsquare.2147dc4b.jpeg";